import { createApp } from 'vue'
import App from './App.vue'
import VueCookies from 'vue-cookies'

// bootstrap-vueからBootstrapVue,IconPluginをインポートする
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue' // add
// Bootstrap と BootstrapVueのCSSファイルをインポート（順序はBootstrap⇒BootstrapVue）
// import 'bootstrap/dist/css/bootstrap.css' // add
// import 'bootstrap-vue/dist/bootstrap-vue.css' // add
import './css/_reset.scss'
import './css/_style.scss'

const app = createApp(App);
app.use(VueCookies)
app.mount('#app')
